import Vue from 'vue'
import Vuex from 'vuex'

import Global from './modules/global'
import Auth from './modules/auth'
import Manager from './modules/manager'
import Client from './modules/client'
import Location from './modules/location'
import Region from './modules/region'
import Map from './modules/map'
import Desk from './modules/desk'
import Report from './modules/report'
import Setting from './modules/setting'
import DeskBooking from './modules/deskbooking'
import Feature from './modules/feature'
import User from './modules/user'
import ServiceDesk from './modules/servicedesk'
import DeskGroups from './modules/deskgroups'
import Locker from './modules/locker'
import Restaurant from './modules/restaurant'
import RestaurantBooking from './modules/restaurantbooking'
import Chartered from './modules/chartered'
import CharteredBooking from './modules/charteredbooking'
import Site from './modules/site'
import Parking from './modules/parking'
import ParkingBooking from './modules/parkingbooking'
import LockerBooking from './modules/lockerbooking'
import CostCenter from './modules/costcenter'
import DeskAttributes from './modules/deskattributes'
import QrCodes from './modules/qrcodes'
import Meal from './modules/meal'
import MealMenu from './modules/mealmenu'
import Team from './modules/team'
import Invite from './modules/invite'
import SpaceOccupancy from './modules/spaceoccupancy'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    Global,
    Auth,
    Manager,
    Client,
    Location,
    Region,
    Map,
    Desk,
    Report,
    Setting,
    DeskBooking,
    Feature,
    User,
    ServiceDesk,
    DeskGroups,
    Restaurant,
    RestaurantBooking,
    Chartered,
    CharteredBooking,
    Site,
    Parking,
    ParkingBooking,
    Locker,
    LockerBooking,
    CostCenter,
    DeskAttributes,
    QrCodes,
    Meal,
    MealMenu,
    Team,
    Invite,
    SpaceOccupancy
  }
})
